import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Text, Container, VStack, Flex, Heading, Stack } from '@chakra-ui/react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';

import { FinderScreen } from './finderScreen';
import { LANDING_SCREEN_PATH, SEARCH_SCREEN_PATH } from '../../support/routeConstants';
import { BtNavigate } from '../../components/BtNavigate';
import { LandingScreen } from '../landing/landingScreen';
import BtCheckbox from '../../components/BtCheckbox';
import BtLoading from '../../components/BtLoading';
import BtFailed from '../../components/BtFailed';
import BtButton from '../../components/BtButton';
import { RootState, store } from '../../app/store';
import BtGroup from '../../components/BtGroup';
import BtHelmet from '../../components/BtHelmet';
import { useSelector } from 'react-redux';

export const Finder: React.FC = () => {
  const viewModel = useAppSelector((state) => state.finder.viewModel);
  const logoUrl = useSelector((state: RootState) => state.gatInformation.logoUrl);
  const viewModelLanding = useAppSelector((state) => state.landing.viewModel);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (FinderScreen.isNone(viewModel)) {
      dispatch(FinderScreen.start(viewModel, logoUrl));
    } else if (FinderScreen.isLoading(viewModel)) {
      (async () => {
        dispatch(await FinderScreen.load(viewModel, logoUrl));
      })();
    }

    if (!store.getState().appState.state.sessionActive && FinderScreen.isFailed(viewModel)) {
      handleNavigate(LANDING_SCREEN_PATH);
    }
  }, [viewModel]);

  const handleCheckBox = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const target = event.target;
    dispatch(FinderScreen.startAddress(viewModel, target.checked, logoUrl));
  };

  const handleNavigate = async (path: string) => {
    if (path.length === 0) {
      dispatch(await LandingScreen.start(viewModelLanding, logoUrl));
      dispatch(await FinderScreen.reset());
      navigate(-1);
    } else {
      dispatch(await LandingScreen.reset(logoUrl));
      navigate(path);
    }
  };

  if (FinderScreen.isLoading(viewModel)) {
    return <BtLoading {...viewModel.loading} />;
  } else if (FinderScreen.isReady(viewModel)) {
    return (
      <>
        <BtHelmet title={viewModel.metaTitle} />
        <Container padding={0} size='xl'>
          <BtNavigate {...viewModel.navigation} onClick={handleNavigate} />
          <Container padding={0} maxW='container.md'>
            <Flex pb={200}>
              <VStack w='full' h='full' p={10}>
                <Heading as='h1' variant='h1' pb={5}>
                  {viewModel.greeting}
                </Heading>
                <Box w='100%' p={4} bg='black' borderRadius='lg' boxShadow='brand'>
                  <VStack spacing='1' w='100%'>
                    <BtGroup items={viewModel.items} />
                    {viewModel.useAddress.visible && (
                      <Stack w='full' spacing={2} p={5}>
                        <Text as='h4' fontSize='xl'>
                          {viewModel.titleUseAddress}
                        </Text>
                        <BtCheckbox {...viewModel.useAddress} onChange={handleCheckBox} />
                      </Stack>
                    )}
                  </VStack>
                  <Box p={5}>
                    <BtButton
                      variant='primary'
                      size='lg'
                      w='full'
                      {...viewModel.next}
                      action={() => navigate(SEARCH_SCREEN_PATH)}
                    />
                  </Box>
                </Box>
              </VStack>
            </Flex>
          </Container>
        </Container>
      </>
    );
  } else if (FinderScreen.isFailed(viewModel)) {
    return <BtFailed {...viewModel.error} />;
  } else {
    return <BtLoading {...viewModel.loading} />;
  }
};
